import React, { useEffect, useRef, useState } from 'react';
import { InputField, RadioButton, SelectField } from 'views/components/form-inputs';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Message } from 'primereact/message';
import { userService } from 'services/user.service';
import { _Object, showTostify } from 'utils/interfaces';
import CustomToast from 'views/components/form-inputs/alert';
import { useNavigate, useParams } from 'react-router-dom';
import { routes } from 'utils/routes';
import { SEOHeader } from 'views/components';
import { Editor } from 'primereact/editor';
import { Calendar } from 'primereact/calendar';
import { blogService } from 'services';
import moment from 'moment';
import { parseISO } from 'date-fns';
import axios from 'axios';
import store from 'store'

const initialValue = {
	title: "",
	slug: null,
	description: "",
	short_description: "",
	publish_date: "",
	status: "published",
	author_id: ""
};

const AddBlogs = () => {
	const toastRef = useRef<any>(null);
	const navigation = useNavigate()
	const params = useParams()
	const id: any = params.id

	const [loading, setLoading] = useState(false);
	const [initialData, setInitialData] = useState(initialValue);
	const [employeeList, setEmployeeList] = useState<any>([]);

  const [selectedFile, setSelectedFile] = useState<any>('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewUrl1, setPreviewUrl1] = useState('');
  const [avatar, setAvatar] = useState<any>([]);

	const fetchEmployeeList = async () => {
		try {
			setLoading(true);
			const data = await userService.getUsers({
				page: '1',
				per_page: '9999',
				sort: '-created_at',
			});
			setEmployeeList(data.items);
		} catch (error) {
			console.error('Error fetching employees:', error);
		} finally {
			setLoading(false);
		}
	};

	const formik: any = useFormik({
		initialValues: initialData,
		enableReinitialize: true,
		validationSchema: Yup.object({
			title: Yup.string().required('Title is required'),
			slug: Yup.string().required('Slug is required'),
			// description: Yup.string().required('Description is required'),
			// short_description: Yup.string().required('Short description is required'),
			publish_date: Yup.string().required('publish Date is required'),
			status: Yup.string().required('Status is required'),
			author_id: Yup.string().required('Author is required'),
		}),
		onSubmit: async (values: any) => {
			setLoading(true);
			try {
				if (id) {
					delete values?.id
					delete values.created_by
					delete values.created_at
					delete values.author
					delete values.media
					delete values.updated_at
					const data = await blogService.updateBlog(id, values);
					if (data.error === false) {
            if (selectedFile) {
              submitFile(id)
            }
						showTostify(toastRef, 'success', data.message);
						setTimeout(() => {
							navigation(`${routes.blogs}`);
						}, 800)
					}
					else {
						showTostify(toastRef, 'error', data.message);
					}
				}
				else {
					const data = await blogService.createBlog(values);
					if (data.error === false) {
            if (selectedFile) {
              submitFile(data.data.id)
            }
						showTostify(toastRef, 'success', data.message);
						formik.resetForm();
						setTimeout(() => {
							navigation(`${routes.blogs}`);
						}, 800)
					}
					else {
						showTostify(toastRef, 'error', data.message);
					}
				}
			} catch (err: any) {
				showTostify(toastRef, 'error', err.message);
			} finally {
				setLoading(false);
			}
		}
	});


	useEffect(() => {
		fetchEmployeeList();
	}, []);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target && e.target.files) {
      const file = e.target.files[0] || null;
      if (file) {
        setSelectedFile(file);
        setPreviewUrl1(URL.createObjectURL(file));
      }
    } else {
      console.error('No files were selected.');
    }
  };

  const submitFile = async (id: any) => {
    if (selectedFile) {
      const data = new FormData();
      data.append('key', 'featured_image');
      data.append('entity_id', `${id}`);
      data.append('files', selectedFile);
      data.append('entity_type', `blog_article`);

      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}v1/admin/media`, data, {
          headers: { 'Content-Type': 'multipart/form-data', 'Authorization': store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9') }
        });
				console.log('response',response);
				
        setPreviewUrl('')
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }
  }
	useEffect(() => {
		if (id) {
			setLoading(true)
			const getBannerDetails = async () => {
				const data = await blogService.getBlogDetails(id);
				if (Array.isArray(data?.media) && data?.media.length > 0) {
          setAvatar(data.media);
        } else {
          console.error('Media array is empty or not an array');
        }
				if (!data.error) {
					setInitialData(data)
					setLoading(false);
				} else {
					showTostify(toastRef, 'error', data.message);
					setLoading(false);
				}
			};
			getBannerDetails();
		}
	}, [id]);

	return (
		<div style={{ width: "800px", margin: "auto" }}>
			<SEOHeader title="Create Customer" />
			<div className='bg-white border-round-2xl'>
				<form onSubmit={formik.handleSubmit} >
					<CustomToast ref={toastRef} />

					<div className="p-4 border-bottom-1 border-primary-color">
						<h2 className='text-start m-0'>{id ? "Edit Blog" : "Add New Blog"}</h2>
					</div>
					<div className="grid m-0 py-4 p-3">
						<div className="grid m-0">
							<div className="col-12 md:col-6 lg:col-12">
								<InputField
									name="title"
									label="Title"
									required={true}
									value={formik.values.title}
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									error={formik?.touched.title && formik.errors.title}
								/>
							</div>
							<div className="col-12 md:col-6 lg:col-6">
								<InputField
									name="slug"
									label="Slug"
									required={true}
									value={formik.values.slug}
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									error={formik?.touched.slug && formik.errors.slug}
								/>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<SelectField
									name="author_id"
									showClear
									filter
									label="Author"
									value={formik.values.author_id}
									onChange={(e) => formik.setFieldValue('author_id', e.value)}
									options={employeeList?.map((item: _Object) => ({ label: `${item.full_name} (${item.id_number})`, value: item.id }))}
									error={formik.touched.author_id && formik.errors.author_id}
									required={true}
									className="my-custom-class"
								/>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div className="form-group mb-2">
									<label htmlFor="publish_date">Publish Date<span className='required-field'>*</span></label>

									<Calendar
										id="publish_date"
										name="publish_date"
										value={formik.values.publish_date ? parseISO(formik.values.publish_date) : null}
										onChange={(e) => {
											if (e.value) {
												const formattedDate = moment(e.value).toISOString();
												formik.setFieldValue('publish_date', formattedDate);
											} else {
												formik.setFieldValue('publish_date', null);
											}
										}}
										showIcon
										minDate={new Date()}
										placeholder="Enter here"
										className={formik.touched?.publish_date && formik.errors?.publish_date ? 'p-invalid' : ''}
									/>
									{formik.touched?.publish_date && formik.errors?.publish_date && (
										<Message severity="error" text={formik.errors.publish_date} />
									)}
								</div>
							</div>

							<div className="col-12 md:col-6 lg:col-6">
								<div>
									<RadioButton
										className="custom-form-check"
										name="status"
										value={formik.values.status || "male"}
										onChange={(e: any) => formik.setFieldValue('status', e.value)}
										options={[
											{ label: 'Published', value: 'published' },
											{ label: 'Draft', value: 'draft' },
											{ label: 'Pending', value: 'pending' },
										]}
										required={true}
										label="Status"
										error={formik.touched.status && formik.errors.status}
									/>
								</div>
							</div>

							<div className="col-12">
								<div className="form-group mb-1">
									<label>Description</label>
								</div>
								<Editor
									value={formik.values?.description}
									onTextChange={(e) => formik.setFieldValue('description', e.htmlValue || '')}
									style={{ height: '150px' }}
									placeholder="Enter here"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
								/>
							</div>

							<div className="col-12">
								<div className="form-group mb-1">
									<label>Short Description</label>
								</div>

								<Editor
									value={formik.values?.short_description}
									onTextChange={(e) => formik.setFieldValue('short_description', e.htmlValue || '')}
									style={{ height: '150px' }}
									placeholder="Enter here"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
								/>
							</div>

							<div className="col-12">
								<div className='form-group mb-2 '>
									<label className="label-form mb-1">Featured Image</label>
								</div>

								<ul className="fileupload p-list p-list-custom list-none flex flex-wrap gap-2 p-0 m-0">
									{previewUrl1 && (
										<li className="p-list-item">
											<img
												src={previewUrl1}
												alt=""
												width={80}
												height={80}
											/>
										</li>
									)}
									{avatar && (avatar?.length > 0 && avatar?.length < 4) &&
										<>
											{avatar.map((item: any) => {
												return (
													<>
														<li className="p-list-item">
															<img src={item?.path} alt="Avatar Preview" width={70} height={70} />
														</li>
													</>
												)
											})}
										</>}
									<li className="p-list-item">
										<div className="avatar-upload">
											<label htmlFor="imageUpload">
												<i className="pi pi-cloud-upload" style={{ fontSize: '20px' }}></i>
											</label>
											<input
												type="file"
												id="imageUpload"
												accept=".png, .jpg, .jpeg"
												onChange={(e) => {
													handleImageChange(e);
												}}
												style={{ visibility: 'hidden' }}
											/>
											<div className="avatar-preview">
												<div className="image-preview">
													{previewUrl && (
														<img src={previewUrl} alt="Avatar Preview" width={200} height={200} />
													)}
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>

						</div>

						<div className="col-12 text-center">
							<Button
								label={id ? "Edit Blog" : "Add Blog"}
								type="submit"
								className="primary"
								loading={loading}
								disabled={loading}
							/>
						</div>
					</div>
				</form>
			</div>
		</div>
	);
};
export default AddBlogs